import React from "react";
import {
  FaHeart,
  FaPlus,
  FaShareAlt,
  FaCommentDots,
  FaSearch,
  FaChevronDown,
  FaPlay,
  FaFlag,
  FaLightbulb,
  FaTv, // Import FaTv từ react-icons/fa
  FaUsers, // Import FaUserGroup từ react-icons/fa
  FaClock,
  FaExpand
} from "react-icons/fa";
import { MdLogout,MdInfoOutline } from "react-icons/md";
import { LiaCommentDots } from "react-icons/lia";
import { GrFormNextLink } from "react-icons/gr";
import { GrFormNext } from "react-icons/gr";

export const ZoomInIcon = ({ className = "" }) => (
  <FaExpand className={`${className}`} />
)

export const GrFormNe = ({ className = "" }) => (
  <GrFormNextLink className={`${className}`} />
)
export const GrFormNext1 = ({ className = "" }) => (
  <GrFormNext className={`${className}`} />
)
export const LogOutIcon = ({ className = "" }) => (
  <MdLogout className={`${className}`} />
)
export const ChiTietIcon = ({ className = "" }) => (
  <MdInfoOutline className={`${className}`} />
);
export const HeartIcon = ({ className = "" }) => (
  <FaHeart className={`${className}`} />
);
export const ClockIcon = ({ className = "" }) => (
  <FaClock className={`${className}`} />
);
export const HeartIconPhim = ({ className = "" }) => (
    <FaHeart className={`${className}`} />
  );

export const PlusIcon = ({ className = "" }) => (
  <FaPlus className={`${className}`} />
);

export const ShareIcon = ({ className = "" }) => (
  <FaShareAlt className={`${className}`} />
);

export const ChatIcon = ({ className = "" }) => (
  <FaCommentDots className={`${className}`} />
);

export const SearchIcon = ({ className = "" }) => (
  <FaSearch className={`${className}`} />
);

export const ChevronDownIcon = ({ className = "" }) => (
  <FaChevronDown className={`${className}`} />
);

export const LiaCommentDotsIcon = ({ className = "" }) => (
  <LiaCommentDots className={`${className}`} />
);

export const PlayIconFill = ({ className = "" }) => (
  <FaPlay className={`${className}`} />
);

export const EpisodePlayIcon = ({ className = "" }) => (
  <FaPlay className={`${className}`} />
);

export const FlagIcon = ({ className = "" }) => (
  <FaFlag className={`${className}`} />
);

export const LightBulbIcon = ({ className = "" }) => (
  <FaLightbulb className={`${className}`} />
);

export const TvIcon = ({ className = "" }) => (
  <FaTv className={`${className}`} />
);

export const UserGroupIcon = ({ className = "" }) => (
  <FaUsers className={`${className}`} />
);

